import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import { getCurrentUrl, getImageUrl } from '@/utils/string';
import TimerFlash from '@/app/components/Timer/TimerFlash';
import { useDispatch } from 'react-redux';
import { setSectionGroupItems } from '@/redux/reducers/campaign-products-reducer';
import { EXTERNAL } from '@/constants';
import { imageTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';

function CampaignGroupSectionHeader({
  section = {},
  targetStartDate,
  targetEndDate,
  topIcon = false,
  showCountDownTimer = false,
}) {
  const router = useRouter();
  const dispatch = useDispatch();

  const handleClick = (e) => {
    dispatch(setSectionGroupItems(section));
    e.stopPropagation();

    const url = section?.redirect_url?.en?.url;
    const urlText = section?.redirect_url?.en?.text;
    const urlType = section?.redirect_url?.en?.type;

    if (url && urlText) {
      if (urlType === EXTERNAL) {
        window.open(url);
      } else {
        router.push(url);
      }
    }
  };

  const isExpired = targetEndDate ? new Date(targetEndDate) < new Date() : true;

  return (
    /*  3xl:max-w-[1440px] */
    <div className={cn('campaign-group-section-header container mx-auto')}>
      <div className="flex justify-between items-center">
        {topIcon ? (
          <Link
            prefetch={false}
            aria-label="Go to campaign section"
            href={section?.redirect_url?.en?.url ?? '#'}
            className={cn(
              section?.redirect_url?.en?.url === getCurrentUrl()
                ? 'cursor-default'
                : '',
            )}
          >
            <ImageComponentV2
              src={topIcon ? getImageUrl(topIcon) : null}
              alt={section?.title?.en}
              className="w-[100px] h-[100px] lg:w-[170px] lg:h-[170px] object-contain object-center"
              type={imageTypes.square}
              width={170}
              height={170}
              loading="lazy"
            />
          </Link>
        ) : null}
        {showCountDownTimer && !isExpired ? (
          <TimerFlash
            targetStartDate={targetStartDate}
            targetEndDate={targetEndDate}
          />
        ) : null}
      </div>
    </div>
  );
}

export default CampaignGroupSectionHeader;
